import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ParticleCalibration } from '../../../../model/particleCalibration';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { ParticleCalibrationService } from '../../../../services/particleCalibration.service';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ManageUsersService } from '../../../../services/manageUsers.service';
import { UserService } from '../../../../services/user.service';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { GroupEnum } from '../../../../utils/groupUtils';
import saveAs from 'file-saver';
import { CalibrationParticlesUtils } from '../../../../utils/calibrationParticlesUtils';

export interface DialogDataAutomaticSignCalibration {
  calibration: ParticleCalibration;
  equipment: InternalEquipment;
}

@Component({
  selector: 'app-particles-edit-automatic-sign-report',
  templateUrl: './particles-edit-automatic-sign-report.component.html',
  styleUrl: './particles-edit-automatic-sign-report.component.scss',
  standalone: false
})
export class ParticlesEditAutomaticSignReportComponent implements OnInit, OnDestroy {

  langs: LangFlag[];
  selectedGroup: number;

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ParticlesEditAutomaticSignReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataAutomaticSignCalibration,
    private calibrationService: ParticleCalibrationService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private manageUsersService: ManageUsersService,
    private userService: UserService) { }

  ngOnInit(): void {
  
    this.langs = this.translationService.configuredLangs;

    const currentProfile = this.userService.currentProfile;

    this.selectedGroup = currentProfile.profiles.find(p => p.idGroup === currentProfile.idActiveProfile)?.idGroup;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOkClick(): void {
    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    const calibration = this.data.calibration;
    const equipment = this.data.equipment;

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

      this.spinnerService.show();

      if (token != null) {
        if (equipment.idClient) {
          this.manageUsersService.checkIfHasUser(equipment.idClient).subscribe(hasUser => {
            if(!hasUser && this.selectedGroup === GroupEnum.QUALIPHARMA){
              this.snackBarService.sendError(this.translate.instant('manageUsers.dialog.clientHasUsers.error') as string);
            } else {
              this.calibrationService.automaticSign(calibration.id, token, "es").pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.sign.ok') as string);

                this.calibrationService.downloadPdfVersion(calibration.id, calibration.currentVersion).pipe(takeUntil(this.destroy$))
                  .subscribe((file: Blob) => {
                    const name = CalibrationParticlesUtils.getNameForCalibration(calibration, equipment, this.translate);
                    saveAs(file, name);

                    this.spinnerService.hide();
                    this.dialogRef.close(token);
                  });
              }, () => {
                this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.sign.error') as string);

                this.spinnerService.hide();
              });
            }
          });
        } else {
          this.calibrationService.automaticSign(calibration.id, token, "es").pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.spinnerService.hide();
            this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.sign.ok') as string);

            this.calibrationService.downloadPdfVersion(calibration.id, calibration.currentVersion).pipe(takeUntil(this.destroy$))
              .subscribe((file: Blob) => {
                const name = CalibrationParticlesUtils.getNameForCalibration(calibration, equipment, this.translate);
                saveAs(file, name);

                this.spinnerService.hide();
                this.dialogRef.close(token);
              });
          }, () => {
            this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.sign.error') as string);

            this.spinnerService.hide();
          });
        }
      } else {
        this.spinnerService.hide();
      }
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }
}
